import { Component, ElementRef, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Focusable } from '../utils/focusable';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-instant-search-box',
	templateUrl: './instant-search-box.component.html',
	styleUrls: ['./instant-search-box.component.scss'],
	providers: [{ provide: Focusable, useExisting: forwardRef(() => InstantSearchBoxComponent) }],
	imports: [IconComponent],
})
export class InstantSearchBoxComponent extends Focusable {
	rawFire$ = new Subject<string>();

	@Input()
	value = '';

	@Input()
	placeholder = 'Zoeken...';

	@Output()
	fire: Observable<string>;

	@ViewChild('inputElement')
	private readonly inputElement?: ElementRef;

	constructor() {
		super();
		this.fire = this.rawFire$.pipe(debounceTime(400));
	}

	rawFireEvent(event: Event) {
		this.rawFire$.next((<HTMLInputElement>event.target).value);
	}

	focus() {
		this.inputElement?.nativeElement.focus();
	}
}
